import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { GeneralService } from '../general.service';
import * as moment from 'moment';
import 'moment-duration-format';
import {TranslateService} from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.scss']
})
export class QuestionsComponent implements OnInit {

  public examTimerString: any = "";
  public extraTimeString: any = "";
  public adaptedTimeString: any = "";
  public showExtraTime = false;
  public showAdaptedTime = false;
  public useQuestionTimer = false;
  public timerInterval;
  public timerTimeout;
  public movingToQuestion = 0;
  
  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService,
    private  domSanitizer: DomSanitizer
  ) {
    if (dataSvc.currentUser.ScheduleCandidate == null || dataSvc.currentUser.Exams.length == 0){
      var enetsecure = this.dataSvc.enetsecureMobile ? "enetsecuremobile=1" : this.dataSvc.enetsecureWeb ? "enetsecureweb=1" : "";
      generalSvc.logoutUser(enetsecure);
    }

    if (dataSvc.currentExamIndex == -1)
      generalSvc.loginUser();

    // find first un-answered question;
    var i = 0;
    var qfound = false;
    dataSvc.currentExam().Questions.forEach(question => {
      if (question.Disabled != true && !qfound){
        dataSvc.setQuestion(i);
        qfound = true;
      }
      i++;
    });

    if (!qfound)
      dataSvc.setQuestion(i);
  }

  ngOnInit() {
    this.initiateTimer();
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }
  }

  

  

  initiateTimer(){
console.log(this.dataSvc.currentExam());
    var questionTimerMode = this.dataSvc.currentExam().Session.UseQuestionTime;
    if(questionTimerMode){
      //use time from questions
      this.useQuestionTimer = true;
      var qtimerMins = 0;
      var questions = this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Questions;
      for(var q = 0; q < questions.length; q++){
        var question = questions[q].Question;
        if(question != null){
          var qTime = question.QuestionTime;
          if(qTime !== null){
            qtimerMins += qTime;
          }
        }
      }
  
      var adaptedTime = 0;
      var scheduleCandidate = this.dataSvc.currentUser.ScheduleCandidate;
      if(scheduleCandidate != null){
        if(scheduleCandidate.ExtraTime != null && scheduleCandidate.ExtraTime > 0){
          adaptedTime += scheduleCandidate.ExtraTime;
        }
      }
  
      qtimerMins += adaptedTime;
  
      var seconds = qtimerMins * 60;
      var checkTime = seconds - this.dataSvc.currentExam().Session.Timetaken;
      var enableFlexibleTimer = this.dataSvc.currentExam().Session.AssessmentEnableExtraTime;
      if(checkTime <= 0){
        if(enableFlexibleTimer){
          this.dataSvc.currentQuestion().Question.ExtraTimeUsed = (checkTime * -1)
        }
      }
      else{
        this.startQuestionTimer(checkTime);
      }
    }
    else{
      //use time from exam
      this.useQuestionTimer = false;
      var timerMins = this.dataSvc.currentExam().Session.AssessmentTime;  
    var adaptedTime = 0;
    var scheduleCandidate = this.dataSvc.currentUser.ScheduleCandidate;
    if(scheduleCandidate != null){
      if(scheduleCandidate.ExtraTime != null && scheduleCandidate.ExtraTime > 0){
        adaptedTime += scheduleCandidate.ExtraTime;
      }
    }

    timerMins += adaptedTime;

    var seconds = timerMins * 60;
    var checkTime = seconds - this.dataSvc.currentExam().Session.Timetaken;
    var enableFlexibleTimer = this.dataSvc.currentExam().Session.AssessmentEnableExtraTime;  
    if(this.dataSvc.demoExam){
      this.startTimer(this.dataSvc.currentExam().Session.AssessmentTime * 60);
    }
    else{
      if(checkTime <= 0 && !enableFlexibleTimer){
          clearInterval(this.dataSvc.interval);
          this.dataSvc.EndExam();
        }
        else{
          this.startTimer(checkTime);
        }
    }
    }   
  }

    startTimer(duration){
      this.dataSvc.currentExam().Session.timer = duration;
      //timer = 15;
      clearInterval(this.dataSvc.interval);
      this.dataSvc.interval = setInterval(() => {
        if (this.dataSvc.isConnected) {          
          var enableFlexibleTimer = this.dataSvc.currentExam().Session.AssessmentEnableExtraTime; 
          //STANDARD ENETASSESS TIMER LOGIC
          this.dataSvc.currentExam().Session.minutes = parseInt(this.dataSvc.currentExam().Session.timer) / 60;
          this.dataSvc.currentExam().Session.seconds = parseInt(this.dataSvc.currentExam().Session.timer) % 60;

          this.dataSvc.currentExam().Session.minutes = this.dataSvc.currentExam().Session.minutes < 10 ? "0" + this.dataSvc.currentExam().Session.minutes : this.dataSvc.currentExam().Session.minutes;
          this.dataSvc.currentExam().Session.seconds = this.dataSvc.currentExam().Session.seconds < 10 ? "0" + this.dataSvc.currentExam().Session.seconds : this.dataSvc.currentExam().Session.seconds;
          var pat = /\b(900)\b/g;
          if (--this.dataSvc.currentExam().Session.timer < 0) {
            if(enableFlexibleTimer){
              clearInterval(this.dataSvc.interval);
              this.startStandardExtraTimer();
              document.getElementById("timerStrPara").style.display = "none";          
            }
            else{
              this.dataSvc.currentExam().Session.timer = 0;
              alert("Exam Finished");
              clearInterval(this.dataSvc.interval);
              this.dataSvc.EndExam();
              this.dataSvc.currentQuestion().Question.ExtraTimeUsed = (this.dataSvc.currentExam().Session.timer * -1)
            }            
          }
          else if(this.dataSvc.currentExam().Session.timer == 900 || this.dataSvc.currentExam().Session.timer.toString().match(pat)){
            document.getElementById("btnOpenTimer").click();
          }
          
          this.dataSvc.currentExam().Session.seconds = this.dataSvc.currentExam().Session.timer;
          this.dataSvc.currentExam().Session.duration = moment.duration(this.dataSvc.currentExam().Session.seconds, 'seconds');          
          this.examTimerString = this.dataSvc.currentExam().Session.duration.format("hh:mm:ss");

          // construct exam time taken;
          this.dataSvc.currentExam().Session.Timetaken++;

          // set time spent on question;
          if (this.dataSvc.currentQuestion().Question.TimeSpent == null || this.dataSvc.currentQuestion().Question.TimeSpent == undefined)
            this.dataSvc.currentQuestion().Question.TimeSpent = 0;

          this.dataSvc.currentQuestion().Question.TimeSpent++;
        }
      }, 1000);
  }
  

  startQuestionTimer(duration){
      this.dataSvc.currentExam().Session.timer = duration;
      //timer = 15;
      clearInterval(this.dataSvc.interval);
      this.dataSvc.interval = setInterval(() => {
        if (this.dataSvc.isConnected) {

          //check to see if task time has elapsed
          
          var task = this.dataSvc.taskQuestion(this.dataSvc.currentQuestion().Question.Question.QuestionID);
          if(task !== null){
            if(task.Percentage >= 100){              
              var adaptedTime = this.dataSvc.currentUser.ScheduleCandidate.ExtraTime;
              if(adaptedTime !== null && adaptedTime !== undefined && adaptedTime !== 0){
                this.dataSvc.currentUser.ScheduleCandidate.ExtraTime -= 1;
                this.dataSvc.currentQuestion().SessionQuestion.AdapatedTimeSpentMins += 1;
                this.showAdaptedTime = true;
                this.adaptedTimeString = moment.duration(this.dataSvc.currentUser.ScheduleCandidate.ExtraTime, 'seconds').format("hh:mm:ss");
              }
              else{
                this.startExtraTimeTimer();
                this.showAdaptedTime = false;
                this.adaptedTimeString = "";
              }
            }
            else{
              this.showAdaptedTime = false;
              this.adaptedTimeString = "";
              this.showExtraTime = false;
              this.examTimerString = "";
              this.dataSvc.currentQuestion().SessionQuestion.TimeSpentMins += 1;
              this.dataSvc.getTaskQuestionTimeUsed();
            }
          }
          // construct exam time taken;
          this.dataSvc.currentExam().Session.Timetaken++;

          // set time spent on question;
          if (this.dataSvc.currentQuestion().Question.TimeSpent == null || this.dataSvc.currentQuestion().Question.TimeSpent == undefined)
            this.dataSvc.currentQuestion().Question.TimeSpent = 0;

          this.dataSvc.currentQuestion().Question.TimeSpent ++;
        }
      }, 1000);
  }

  startStandardExtraTimer(){
    this.dataSvc.currentExam().Session.ExtraTimetaken = 1;
    this.dataSvc.interval = setInterval(() => {
      if(this.dataSvc.currentExam().Session.AssessmentEnableExtraTime){
        this.dataSvc.currentExam().Session.Timetaken++;
        var currentExtraTime = this.dataSvc.currentExam().Session.ExtraTimetaken;
        this.dataSvc.currentQuestion().SessionQuestion.ExtraTimeSpentMins += 1;         
        if(currentExtraTime !== null && currentExtraTime > 0){
          this.showExtraTime = true;          
          this.extraTimeString = moment.duration(currentExtraTime, 'seconds').format("hh:mm:ss");
          this.dataSvc.currentExam().Session.ExtraTimetaken++;
        }
      }
    },1000);
  }

  startExtraTimeTimer(){

    if(this.dataSvc.currentExam().Session.AssessmentEnableExtraTime){
      this.dataSvc.currentQuestion().SessionQuestion.ExtraTimeSpentMins += 1;
        var taskExtraTime = this.dataSvc.checkTaskForExtraTimeUsed(this.dataSvc.currentQuestion().Question.Question.QuestionID);
        if(taskExtraTime !== null && taskExtraTime > 0){
          this.showExtraTime = true;          
          this.extraTimeString = moment.duration(taskExtraTime, 'seconds').format("hh:mm:ss");
        }
        else{
          this.showExtraTime = false;
          this.extraTimeString = "";
        }
    }
    else{
      console.log(this.dataSvc.currentExam());
      var timeRemainingQuestions = this.dataSvc.currentExam().Tasks.filter(x => x.TimeUsed < x.Timer);
      
      if(timeRemainingQuestions !== null && timeRemainingQuestions !== undefined){
        if(timeRemainingQuestions.length > 0){
          var questionId = timeRemainingQuestions[0].QuestionIds.split(',')[0];
          var questionIndex = 0;
          this.dataSvc.currentExam().SessionQuestions.forEach(question => {
            if (question.QuestionId.toString() === questionId){
              this.movingToQuestion = (questionIndex + 1);              
              this.dataSvc.showTimerAlert = true;
              this.dataSvc.showTimerAlertCounter = 5;
              clearInterval(this.timerInterval);
                this.timerInterval = setInterval(() => { 
                  this.dataSvc.showTimerAlertCounter += -1; 
              }, 1000);

              clearTimeout(this.timerTimeout);
              this.timerTimeout = setTimeout(() => { 
                  this.dataSvc.showTimerAlert = false; 
                  clearInterval(this.timerInterval);
              }, 6000);
              this.dataSvc.setQuestion(questionIndex);
            }
            questionIndex++;
          });
        }   
        else{
          alert("There is no time remaining on any of the questions. Your exam has now finished.");
          this.dataSvc.EndExam();
        }     
      }
      else{
        alert("There is no time remaining on any of the questions. Your exam has now finished.");
        this.dataSvc.EndExam();
      }
    }        
  }

  isExamTimeFinished(endTime, startTime, allottedTime){
    var now = moment().format();
    var end = moment(endTime).format();
    if(now >= end){
      //clearInterval(this.dataSvc.interval);
      //this.dataSvc.EndExam();
    }
    else{
      var start = moment(startTime).format();
      var difference = moment.duration(moment().diff(moment(start))).as('minutes');
      var minutes = difference;
      var allowedtime = (parseInt(allottedTime) * 60);
      var correctTime = allowedtime - (minutes * 60);
      return correctTime;
    }
  }

  getStyles(){
    var css = this.dataSvc.currentExam().Session.AssessmentThemeCss;
    if(css !== null && css !== undefined && css !== ""){
      var cssStr = "<style>" + css + "</style>";
      return this.domSanitizer.bypassSecurityTrustHtml(cssStr);
    }
  }

  
}